import { LabelType, LabelValueSource, Label } from 'graphql/types';
import { mapDefaultValue } from 'modules/timesheet-labels/hooks/utils';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

export const mapBasicLabel = (
  label: Label,
  isSmartSuggestionEnabled: boolean
): TimesheetLabel => {
  const value: TimesheetLabel = {
    id: label.id,
    type: label.type,
    name: label.name,
    origin: label.origin
  };

  if (label.type === LabelType.Text || label.type === LabelType.Numeric) {
    if (label.defaultValue) {
      value.defaultValue = label.defaultValue;
      value.value = {
        stringValue: label.defaultValue?.stringValue,
        numericValue: label.defaultValue?.numericValue
      };
    }
    value.valueSource = isSmartSuggestionEnabled
      ? LabelValueSource.Suggestion
      : LabelValueSource.User;
    value.acceptedBy = null;
  }
  return value;
};

export const mapSelectLabel = (
  isSmartSuggestionEnabled: boolean,
  label: Label
): TimesheetLabel => {
  const selectLabel: TimesheetLabel = {
    id: label.id,
    type: label.type,
    name: label.name,
    defaultValue: label.defaultValue,
    value: mapDefaultValue(label, null),
    valueSource: isSmartSuggestionEnabled
      ? LabelValueSource.Suggestion
      : LabelValueSource.User,
    origin: label.origin
  };
  if (isSmartSuggestionEnabled) {
    selectLabel.suggestedValues = undefined;
    selectLabel.acceptedBy = null;
  }
  return selectLabel;
};

export const mapTimesheetLabel = (
  label: Label,
  isSmartSuggestionEnabled: boolean
): TimesheetLabel =>
  label.type === LabelType.Select
    ? mapSelectLabel(isSmartSuggestionEnabled, label)
    : mapBasicLabel(label, isSmartSuggestionEnabled);
